import * as React from "react"
import { Route, Redirect } from "react-router-dom"
import { getState } from "store"
import { loginWithToken } from "data/auth"
import { connect } from "react-redux"

class PrivateRoute extends React.Component {
  state = {
    finished: false,
  }
  isAllowed = () => {
    const { guestOnly } = this.props

    const isAuthenticated = getState().auth.isAuthenticated

    return guestOnly ? !isAuthenticated : isAuthenticated
  }

  static defaultProps = {
    guestOnly: false,
    exact: true,
    redirectTo: "/admin",
  }

  renderRoute = props => {
    const { component: Component, redirectTo } = this.props

    if (this.isAllowed()) {
      return <Component {...props} />
    }

    return (
      <Redirect
        to={{ pathname: redirectTo, state: { from: props.location } }}
      />
    )
  }

  render() {
    const { component: Component, ...rest } = this.props
    const { finished } = this.state

    if (!finished) {
      const token = localStorage.getItem("token")
      if (token) {
        this.props.loginWithToken(() => this.setState({ finished: true }))
      } else {
        this.setState({ finished: true })
      }
    }
    return finished && <Route {...rest} render={this.renderRoute} />
  }
}

export default connect(
  null,
  {
    loginWithToken,
  }
)(PrivateRoute)



// WEBPACK FOOTER //
// src/utils/PrivateRoute/index.jsx